require('./bootstrap');

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]')
        }
    });

    // Main Slider
    $('.slides').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 5000,
        fade: true,
        adaptiveHeight: true,
        cssEase: 'linear'
    });

    $('.testimonial-box').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 4000,
        speed: 200,
        fade: false,
        cssEase: 'linear'
    });

    // Menu

    $('#hamburger').click(function(){
        $(this).toggleClass('open');
        openNav();
    });

    function openNav() {
        $(".sidenav").toggleClass('open');
    }


    // Slider Stickers
    var images = ['slider-sticker-1.png', 'slider-sticker-2.png', 'slider-sticker-3.png'],
    index  = 0;
    var listItems = $(".slider-stickers li");
    listItems.each(function(idx, li) {
        var product = $(li);
        product.wrap('<div class="slider-sticker"><p></p></div>');
    });
    var sliderStickers = $(".slider-sticker");
    var li = $(".slider-sticker li");
    li.unwrap();
    sliderStickers.each(function(idx, div) {
        var sliderSticker = $(div);
        if(index == images.length)index=0;
        console.log(index);
        sliderSticker.css({
            'position': 'relative',
            'background-image': 'url(/img/' + images[index++] + ')',
            'background-size':'contain',
            'background-repeat':'no-repeat',
        });
    });
    // Message timeout
    setTimeout(function() {
        $('.message').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 5000);

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function() {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });
});

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
   return string.split(subString, index).join(subString).length;
}


// WEBPACK FOOTER //
// ./resources/assets/js/app.js